{
  "verse": {
    "loading": "Ana lodin aya...",
    "error": "Ba a iya lodin aya ba",
    "reference": "— Sura {{surah}}, Aya {{ayah}}",
    "arabicUnavailable": "(Larabci babu)",
    "english": "Turanci",
    "arabic": "العربية",
    "swapLanguage_aria": "Canza harshe",
    "toggleLanguage_title": "Sauya Turanci / Larabci",
    "reflect": "Yi tunani",
    "reflecting": "Ana tunani…",
    "reflect_aria": "Samar da tunani na sirri da ke haɗa wannan aya da niyyarka",
    "insights": "Fahimta",
    "insights_aria": "Buɗe Fahimtar Alƙur'ani ta AI",
    "share": "Raba",
    "share_aria": "Raba wannan aya a matsayin hoto",
    "share_title": "Raba wannan aya",
    "removeFromFavorites_aria": "Cire daga waɗanda ake so",
    "saveToFavorites_aria": "Ajiye cikin waɗanda ake so",
    "favoritesProLocked_aria": "Waɗanda ake so fasalin Pro ne",
    "favoritesUpgrade_aria": "Haɓaka don ajiye waɗanda ake so",
    "signInToSave": "Shiga don ajiye waɗanda ake so.",
    "failedToUpdateFavorites": "An kasa sabunta waɗanda ake so",
    "couldNotReflect": "Ba a iya samar da tunani ba",
    "shareCaption": "\"{{text}}\"\n— Sura {{surah}}, Aya {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "An ajiye hoto · an kwafi aya",
    "imageSaved": "An ajiye hoton aya",
    "couldNotCreateImage": "Ba a iya ƙirƙirar hoto ba"
  },
  "insights": {
    "panel_aria": "Allon Fahimtar Alƙur'ani",
    "title": "Fahimta",
    "reference": "Sura {{surah}}, Aya {{ayah}}",
    "close_aria": "Rufe allon Fahimta",
    "versePreview_aria": "Samfurin aya",
    "back_aria": "Koma baya",
    "tryAgain": "Sake gwadawa",
    "backTo_aria": "Koma zuwa {{ref}}",
    "copyVerse_aria": "Kwafi {{ref}}",
    "openingVerse": "Ana buɗe ayar…",
    "verseError": "An kasa buɗe ayar."
  },
  "proGate": {
    "title": "Fahimtar Alƙur'ani ta AI fasalin Pro ne",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "Buɗe zurfin fahimtar kowace aya.",
    "bulletAsk": "Yi kowace tambaya game da aya",
    "bulletTafsir": "Taƙaitaccen tafsiri nan take ta AI",
    "bulletRelated": "Gano ayoyi masu alaƙa ta jigo",
    "upgrade": "Haɓaka zuwa Pro"
  },
  "ask": {
    "heading": "Tambaya",
    "suggestion1": "Menene faɗin mahallin wannan aya?",
    "suggestion2": "Ta yaya zan iya amfani da wannan a rayuwar yau da kullum?",
    "suggestion3": "Menene malaman gargajiya suka faɗa game da wannan?",
    "placeholder": "Yi kowace tambaya game da wannan aya…",
    "input_aria": "Yi tambaya game da wannan aya",
    "submit_aria": "Tura tambaya",
    "submit_title": "Tura (⌘↵)",
    "submit_label": "Tambaya",
    "submit_hint": "⌘↵",
    "suggestions_aria": "Tambayoyin da aka ba da shawara",
    "error": "An kasa samun amsa.",
    "pending": "Ana yin nazari kan tambayarka…",
    "attribution": "Amsar da AI ya samar · Ba madadin ilimin ƙwararru ba"
  },
  "tafsir": {
    "heading": "Tafsiri",
    "emptyText": "Sami taƙaitaccen tafsiri da AI ya samar don wannan aya.",
    "generate": "Samar da Tafsiri",
    "commentary": "Sharhi",
    "regenerate": "Sake samarwa",
    "regenerate_aria": "Sake samar da tafsiri",
    "attribution": "Taƙaitawar da AI ya samar · Ba madadin ilimin ƙwararru ba",
    "error": "An kasa ƙirƙirar tafsiri.",
    "pending": "Ana karanta sharhi…"
  },
  "related": {
    "heading": "Ayoyi Masu Alaƙa",
    "copied": "An kwafi: {{ref}}",
    "failedToCopy": "An kasa kwafi",
    "empty": "Ba a samu ayoyi masu alaƙa ba.",
    "error": "An kasa loda ayoyi masu alaƙa.",
    "pending": "Ana nemo ayoyi masu alaƙa…"
  },
  "favorites": {
    "panel_aria": "Ayoyin da ake so",
    "title": "Ayoyin da Ake So",
    "proLocked": "Waɗanda ake so na aya fasalin Pro ne.",
    "loading": "Ana lodi…",
    "failedToLoad": "An kasa lodin waɗanda ake so",
    "empty": "Babu waɗanda ake so har yanzu. Danna zuciya a kan kowace aya don ajiye ta.",
    "reference": "— Sura {{surah}}, Aya {{ayah}}",
    "remove_aria": "Cire daga waɗanda ake so",
    "failedToRemove": "An kasa cirewa"
  }
}
